import * as React from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

import { extras as themeExtras } from '../../../shared/theme'

const Headline: React.FC<{
    title: React.ReactNode
    actionBar?: React.ReactNode
}> = React.memo(function Headline(props) {
    return (
        <Box display='flex' flexDirection='column' rowGap={2}>
            <Box
                display='flex'
                justifyContent='space-between'
                alignItems='center'
                mt={3}
            >
                <Typography variant='h4' component='h2'>
                    {props.title}
                </Typography>
                {props.actionBar}
            </Box>
            <Divider
                sx={{
                    borderColor: themeExtras.primaryLight,
                    my: 1,
                }}
            />
        </Box>
    )
})

export default Headline
